/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  /**
   * Weight to render the SVG in. Defaults to "normal"
   */
  weight?: "thin" | "normal";
}
export const IconCalendar = ({
  fill = "none",
  stroke = "currentColor",
  weight = "normal",
  ...props
}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    css={css`
      * {
        vector-effect: non-scaling-stroke;
      }
      overflow: visible;
      height: 24px;
    `}
    {...props}
  >
    <g
      fill={fill}
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={weight === "normal" ? 1.5 : 1}
    >
      <path d="M2.25 3.75h19.5a1.5 1.5 0 0 1 1.5 1.5v16.5a1.5 1.5 0 0 1-1.5 1.5H2.25a1.5 1.5 0 0 1-1.5-1.5V5.25a1.5 1.5 0 0 1 1.5-1.5M.75 9.75h22.5M6.75 6V.75M17.25 6V.75M5.625 13.5z" />
      <path d="M5.625 13.5a.375.375 0 1 0 0 .75.375.375 0 0 0 0-.75M5.625 18.75zM5.625 18.75a.375.375 0 1 0 0 .75.375.375 0 0 0 0-.75M12 13.5zM12 13.5a.375.375 0 1 0 0 .75.375.375 0 0 0 0-.75M12 18.75zM12 18.75a.375.375 0 1 0 0 .75.375.375 0 0 0 0-.75M18.375 13.5zM18.375 13.5a.375.375 0 1 0 0 .75.375.375 0 0 0 0-.75M18.375 18.75zM18.375 18.75a.375.375 0 1 0 0 .75.375.375 0 0 0 0-.75" />
    </g>
  </svg>
);
